import angular from 'angular';

angular
    .module('app')

    .factory('DateService', [
        function() {
            // L'instance du service
            var dateService = {};

            // Formate la date fournie sous la forme YYYYMMDD_HHMM
            dateService.formatAsYMD_HM = function(date) {
                var hours = pad('00', date.getHours());
                var minutes = pad('00', date.getMinutes());

                var year = date.getFullYear();
                var month = pad('00', date.getMonth() + 1);
                var day = pad('00', date.getDate());

                return year + month + day + '_' + hours + minutes;
            };

            // pad("00000", 123) -> "00123"
            function pad(pad, str) {
                if (typeof str === 'undefined') return pad;
                return (pad + str).slice(-pad.length);
            }

            return dateService;
        }
    ]);
